import React from "react";
import {Base} from "./Base";
import './../static/css/sadservice.css';

export const SadService = ({children}) => {
    return <Base>
        {children}
    </Base>
};
